import * as React from 'react'
import styled from 'styled-components'
import Svg from './Svg'

function BaseComponent(props: any) {
  return (
    <Svg
      width={15}
      height={15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.109 14L9.466 1h1.352L5.46 14H4.109z"
        fill="currentColor"
      />
    </Svg>
  )
}

const SvgSlash = styled(BaseComponent)`
  outline: none;
`
export default SvgSlash
